const type = 'SET_PCI_CARD_INFO';

const setPCICardInfo = (data) => ({
  data,
  type,
});

export default setPCICardInfo;
